// extracted by mini-css-extract-plugin
export default {"footerSection":"selected-tab_footerSection__ClbTG"};